/**
 * Created by wangyushen on 2020/9/21.
 */
import yxpapi from '@yxpapi';

export default new yxpapi.JAVAAPI({
    /* 获取分类列表 */
    getAgreementList: {
        url: '/api/crm/agreementContent/agreementContentList',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    /* 复制协议 */
    agreementCopy: {
        url: '/api/crm/agreementContent/agreementContentCopy',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    /* 删除协议 */
    deleteAgreement: {
        url: '/api/crm/agreementContent/delete',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    /* 获取协议内容 */
    getAgreementContent: {
        url: '/api/crm/agreementContent/getDetail',
        method: 'get',
        options: {
            auth: false,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'orgId': 1,
                'Authorization': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2MjYyNDkxMDEsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.relNxJSVwldHtJB4sdriZv6HsOAJbqKOZVbT1U_ZL48',
            },
        },
    },
    /* 获取新老平台应用 */
    getApplicationList: {
        url: '/api/operation/application/app/searchMixList',
        method: 'get',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    /* 保存协议 */
    saveAgreement: {
        url: '/api/crm/agreementContent/addAgreementContent',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    /* 获取最新版本号 */
    getAgreementVersion: {
        url: '/api/crm/agreementContent/getVersion',
        method: 'get',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
});
